module.exports = __webpack_public_path__ + "img/truckHead-dark-grey.527dc119.svg";